/**
 * Token-based substring match: the query is split into whitespace-separated tokens and every token
 * must appear somewhere in the haystack, in any order. Trimmed and case-insensitive.
 *
 * Matches "royal london", "london royal" and "roy lon" against "Royal London ISA".
 * An empty query matches everything.
 */
export const matchesAllTokens = (haystack: string, query: string): boolean => {
  const tokens = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) {
    return true;
  }
  const target = haystack.toLowerCase();
  return tokens.every(token => target.includes(token));
};
